import { render, staticRenderFns } from "./TeamsportPlayerPoolPlayersLookingForTeamsCard.vue?vue&type=template&id=1023dc0c"
import script from "./TeamsportPlayerPoolPlayersLookingForTeamsCard.vue?vue&type=script&lang=js"
export * from "./TeamsportPlayerPoolPlayersLookingForTeamsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
